// Importa los contextos
import { useDataContext } from './AuthContext';
import { useEffect, useState, useContext, createContext } from 'react';
import { getUserDebts } from '../services/api';
export const DebtsContext = createContext();

export function DebtsContextProvider(props) {
  
  const { contextData } = useDataContext();
  const {id: customer_id, order_id} = contextData.customer;

  const [userDebts, setUserDebts] = useState([]);

  useEffect(() => {
    const fetchUserDebts = async () => {
      // 🪤 El efecto corría con el customer_id solo y pedía /getAccountSummary/123/undefined: un
      // 400 por pedido, invisible para el cliente (el catch solo loguea) y 19 de 41 líneas del
      // log del 27-10-2026. Al toque vuelve a correr con el order_id puesto.
      if (customer_id && order_id) {
        try {
          const data = await getUserDebts(customer_id, order_id);
          setUserDebts(data);
        } catch (error) {
          console.error('Error al obtener las deudas del usuario:', error);
        }
      }
    };
  
    fetchUserDebts();
  }, [customer_id, order_id]);
  
  const value = { userDebts, setUserDebts };

  return (
    <DebtsContext.Provider value={value}>
      {props.children}
    </DebtsContext.Provider>
  );
}

export function useDebtsContext() {
  const context = useContext(DebtsContext);
  if (!context) {
    throw new Error('useDebtsContext debe ser utilizado dentro de un DebtsContextProvider');
  }
  return context;
}

